import { useQuery } from '@tanstack/react-query';

import { getAssistantFolders } from '@/api/generated/assistant/assistant';
import { queryKeys } from '@/config/query/queryKeys';

interface UseFoldersOptions {
  enabled?: boolean;
}

export function useFolders({ enabled = true }: UseFoldersOptions = {}) {
  return useQuery({
    enabled,
    queryFn: async () => {
      const response = await getAssistantFolders();
      return response.folders ?? [];
    },
    queryKey: queryKeys.chat.folders(),
    staleTime: 5 * 60 * 1000,
  });
}
